const config = {
    API_URL: window.env?.REACT_APP_BACKEND_URL || "http://default-api.com",

    APP_VERSION:  window.env?.REACT_APP_CONFIG_VERSION || "1.0.0.1",
     REACT_APP_DOMAIN: window.env?.REACT_APP_DOMAIN || "http://91.108.111.207:3000/"

  
    
  };
  
  export default config;
  
